import {
  // TokenPairImage as UIKitTokenPairImage,
  TokenPairImageProps as UIKitTokenPairImageProps,
  TokenImage as UIKitTokenImage,
  ImageProps,
  TokenLogo,
} from '@pancakeswap/uikit'
import { Token, ChainDefaultId, ChainConfig, WNATIVE } from '@pancakeswap/sdk'
import Wrapper from '@pancakeswap/uikit/src/components/Image/Wrapper'
import { BAD_SRCS } from 'components/Logo/constants'
import styled from 'styled-components'
import { variant as StyledSystemVariant } from "styled-system";
import { Variant, variants } from '@pancakeswap/uikit/src/components/Image/types'
import { TokenLogoProps } from '@pancakeswap/uikit/src/components/TokenLogo/TokenLogo'

interface TokenPairImageProps extends Omit<UIKitTokenPairImageProps, 'primarySrc' | 'secondarySrc'> {
  primaryToken: Token
  secondaryToken: Token
}

interface StyledImageProps extends TokenLogoProps {
  variant: Variant;
}

const getImageUrlFromToken = (token: Token) => {
  const WETH = WNATIVE[token.chainId]
  if(token.address===WETH.address)
    return `/images/symbols/${WETH.symbol.toLowerCase()}.png` 
  const address = token?.isNative ? token.wrapped.address : token.address
  const config = Object.entries(ChainConfig[token.chainId]).find(([_key, val]) => address.toLowerCase()===String(val).toLowerCase())
  if(config)
    return `/images/symbols/${config[0].toLowerCase()}.png`
  if (token.chainId !== ChainDefaultId) {
    return `/images/${token.chainId}/tokens/${address}.png`
  }
  return `/images/tokens/${address}.png`
}

const getImageUrlsFromToken = (token: Token) => {
  const WETH = WNATIVE[token.chainId]
  if(token.address===WETH.address)
    return [`/images/symbols/${WETH.symbol.toLowerCase()}.png`] 
  const address = token?.isNative ? token.wrapped.address : token.address
  const config = Object.entries(ChainConfig[token.chainId]).find(([_key, val]) => address.toLowerCase()===String(val).toLowerCase())
  if(config)
    return [`/images/${token.chainId}/symbols/${config[0].toLowerCase()}.png`, `/images/symbols/${config[0].toLowerCase()}.png`]
  return [`/images/tokens/${address}.png`]
}

const StyledPrimaryImage = styled(TokenLogo)<StyledImageProps>`
  position: absolute;
  width: ${({ variant }) =>
    variant === variants.DEFAULT ? "92%" : "82%"}; // 92, 82 are arbitrary numbers to fit the variant

  ${StyledSystemVariant({
    variants: {
      [variants.DEFAULT]: {
        bottom: "auto",
        left: 0,
        right: "auto",
        top: 0,
        zIndex: 5,
      },
      [variants.INVERTED]: {
        bottom: 0,
        left: "auto",
        right: 0,
        top: "auto",
        zIndex: 6,
      },
    },
  })}
`;

const StyledSecondaryImage = styled(TokenLogo)<StyledImageProps>`
  position: absolute;
  width: 50%;

  ${StyledSystemVariant({
    variants: {
      [variants.DEFAULT]: {
        bottom: 0,
        left: "auto",
        right: 0,
        top: "auto",
        zIndex: 6,
      },
      [variants.INVERTED]: {
        bottom: "auto",
        left: 0,
        right: "auto",
        top: 0,
        zIndex: 5,
      },
    },
  })}
`;

export const TokenPairImage: React.FC<React.PropsWithChildren<TokenPairImageProps>> = ({
  primaryToken,
  secondaryToken,
  variant = variants.DEFAULT,
  ...props
}) => {
  const primarySrcs = getImageUrlsFromToken(primaryToken)
  const secondarySrcs = getImageUrlsFromToken(secondaryToken)
  return (
    <Wrapper position="relative" {...props}>
      <StyledPrimaryImage variant={variant} badSrcs={BAD_SRCS} srcs={primarySrcs} {...props}/>
      <StyledSecondaryImage variant={variant} badSrcs={BAD_SRCS} srcs={secondarySrcs} {...props}/>
    </Wrapper>
  )
  // return (
  //   <UIKitTokenPairImage
  //     // primarySrc={getImageUrlFromToken(primaryToken)}
  //     primarySrc={undefined}
  //     secondarySrc={getImageUrlFromToken(secondaryToken)}
  //     primaryImageProps={{
  //       srcSet: getImageUrlsFromToken(primaryToken)
  //     }}
  //     {...props}
  //   />
  // )
}

interface TokenImageProps extends ImageProps {
  token: Token
}

export const TokenImage: React.FC<React.PropsWithChildren<TokenImageProps>> = ({ token, ...props }) => {
  return <UIKitTokenImage src={getImageUrlFromToken(token)} {...props} />
}
